import { render, staticRenderFns } from "./customerInput.vue?vue&type=template&id=8eb6dfc4&scoped=true&"
import script from "./customerInput.vue?vue&type=script&lang=js&"
export * from "./customerInput.vue?vue&type=script&lang=js&"
import style0 from "./customerInput.vue?vue&type=style&index=0&id=8eb6dfc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb6dfc4",
  null
  
)

export default component.exports